import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { hasAnalyticsConsent, CONSENT_EVENT } from "@/lib/analytics";

const GA4_ID = process.env.REACT_APP_GA4_ID;

const loadGtag = () => {
  if (window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "granted",
  });
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID, { send_page_view: false, anonymize_ip: true });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);
};

const GoogleAnalytics = () => {
  const { pathname, search } = useLocation();
  const [consented, setConsented] = useState(false);

  useEffect(() => {
    const sync = () => setConsented(hasAnalyticsConsent());
    sync();
    window.addEventListener(CONSENT_EVENT, sync);
    return () => window.removeEventListener(CONSENT_EVENT, sync);
  }, []);

  useEffect(() => {
    if (!GA4_ID || !consented || pathname.startsWith("/admin")) return;
    loadGtag();
    window.gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: pathname + search,
      page_title: document.title,
    });
  }, [consented, pathname, search]);

  return null;
};

export default GoogleAnalytics;
